export type ProductSchedulingMode = 'fringes' | 'hallTimeslots' | 'none';

export const getProductSchedulingMode = (context: { app?: { config?: any } }): ProductSchedulingMode => {
    const mode = context?.app?.config?.productSchedulingMode;
    return mode === 'fringes' || mode === 'hallTimeslots' || mode === 'none' ? mode : 'hallTimeslots';
};

export const isFringeMode = (context: { app?: { config?: any } }) => getProductSchedulingMode(context) === 'fringes';
export const isHallTimeslotsMode = (context: { app?: { config?: any } }) => getProductSchedulingMode(context) === 'hallTimeslots';
export const isNoneMode = (context: { app?: { config?: any } }) => getProductSchedulingMode(context) === 'none';
